<div class="sk-cms-sidebar"
    {{if style.background.styleType != 'default'}}
        {{if style.background.backgroundType == 'color'}}
            style="background-color:{{style.background.color}}"
        {{/if}}
        {{if style.background.backgroundType == 'img'}}
            style="background-image:url('{{style.background.imgUrl}}')"
        {{/if}}
    {{/if}}
>
    <ul class="sidear-list {{style.bgLineStyle.model == 'hide' ? 'hide-cb' : ''}} {{style.lineStyle.model == 'hide' ? 'hide-hb' : ''}}"
        {{if style.bgLineStyle.model == 'custom'}}
        style="border-color:{{style.bgLineStyle.color}}; border-style:{{style.bgLineStyle.line}}"
        {{/if}}
    >
        {{each content.items}}
        {{if $value.isShow == 1}}
        <li class="sidear-item">
            <div class="sidear-icon"
            {{if $value.isDefault == 1}}
                onclick="$sk.backToTop(0)" cms-not-replace
            {{/if}}>
                {{if $value.linkType == 'custom' && !isDesign}}
                <a href="{{$value.link}}" target="_blank">
                {{/if}}
                {{if $value.icon}}
                <img class="sidear-img" src="{{$value.icon}}">
                {{else}}
                <img class="sidear-img" src="{{content.img}}">
                {{/if}}
                {{if $value.iconhover}}
                <img class="sidear-img" src="{{$value.iconhover}}">
                {{else}}
                <img class="sidear-img" src="{{content.imgurl}}">
                {{/if}}
                {{if $value.linkType == 'custom' && !isDesign}}
                </a>
                {{/if}}
            </div>
            {{if $value.isHover == 1}}
            <div class="sidear-hover">
                <div class="sidear-show"
                     style="{{if style.floatbg.styleType != 'default'}}
                                {{if style.floatbg.backgroundType == 'color'}}
                                    background-color:{{style.floatbg.color}};border-color:{{style.floatbg.color}};
                                {{/if}}
                                {{if style.floatbg.backgroundType == 'img'}}
                                    background-image:url('{{style.floatbg.imgUrl}}');
                                {{/if}}
                            {{/if}}
                            {{if style.lineStyle.model != 'default'}}
                                box-shadow: 0 0 15px {{style.lineStyle.color}};
                            {{/if}}">
                    <img class="sidear-img" src="{{$value.image}}">
                </div>
            </div>
            {{/if}}
        </li>
        {{/if}}
        {{/each}}
    </ul>
</div>